<template><!--
            作者：luoyiming
            时间：2020-04-20
            描述：修改价格
        -->
        <div>

            <el-dialog title="审核订单" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
                :close-on-press-escape="false" width="40%">
                <el-radio v-model="radio" :label="1">通过</el-radio>
                <!-- <el-radio v-model="radio" :label="0">驳回</el-radio> -->
                <!-- <el-input v-model="input" placeholder="请输入备注信息" style="margin-top:10px;"></el-input> -->
                <el-checkbox-group v-model="shneheList" style="margin-top: 20px;">
                    <el-checkbox v-for="item in zqlist" :label="item.bill_id" :key="item.bill_id"
                        :disabled="item.is_pay_status == 1 ? true : false">{{ '第' + item.current_period + '期' }} {{
                            item.repayment_date
                        }} {{ item.price + '元' }}
                    </el-checkbox>
                </el-checkbox-group>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible">取 消</el-button>
                    <el-button type="primary" @click="submitFunc()" :loading="loading">确 定</el-button>
                </div>
            </el-dialog>
             <!-- 密码弹窗 -->
            <el-dialog title="请输入密码" :visible.sync="dialogVisible6" width="20%">
                <div style="height:100px;">
                <el-input placeholder="请输入密码" v-model="sdinput" show-password></el-input>
                <div style="margin-top:20px;display: flex;justify-content:center;"><el-button type="primary" @click="sdqd()">确定</el-button></div>
                </div>
            </el-dialog>
        </div>
</template>

<script>
import OrderApi from '@/api/order.js';
export default {
    data() {
        return {
            // input:"",
            // order_id: 0,
            loading: false,
            shneheList: [],
            /*左边长度*/
            formLabelWidth: '100px',
            /*是否显示*/
            dialogVisible: true,
            /*表单*/
            // order: {
            //     update_price: 0,
            //     update_express_price: 0.00,
            // },
            radio: 1,
            status: '',
            zqlist: "",
            dialogVisible6:false,
            sdinput:""

        };
    },
    props: ['open_edit', 'order', 'order_id'],
    created() {
        let Params = {
            order_id: this.order_id,
        }
        OrderApi.billinfo(Params, true)
            .then(res => {
                console.log("res", res);
                this.zqlist = res.data.list;
                let sj = res.data.list
                for (let i = 0; i < sj.length; i++) {
                    this.zqlist[i].repayment_date = this.formatDate(sj[i].repayment_date);
                }
            })
            .catch(error => {
                console.log("error", error);
            });
    },
    methods: {
        sdqd(){
            console.log(this.sdinput);
            OrderApi.checkpwd({
                password: this.sdinput
            }, true).then(data => {
                console.log(data, "成功");
                if (data.msg == "操作成功") {
                this.dialogVisible6 = false;
                console.log(this.shneheList);
                OrderApi.toExamine1({
                    billid: this.shneheList,
                    order_id: this.order_id,
                    status: 2
                }, true).then(data => {
                    this.dialogVisible = false;
                    console.log(data, "成功");
                    this.$message({
                    message: '操作成功',
                    type: 'success'
                    });
                })
                } else {
                this.$message.error('操作失败');
                }
            })

        },
        // 获取数据
        submitFunc() {
            let self = this;
            console.log(self.shneheList);
            // if (self.shneheList.length <= 0) {
            //     self.$message({
            //         message: '请选择归还期数',
            //         type: 'error'
            //     });
            //     return;
            // }
            if (self.radio == 1) {
                self.status = 2;// status 2 通过
            } else {
                self.status = 20;
            }
            if(self.shneheList.length <= 0){
                OrderApi.toExamine1({
                order_id: self.order_id,
                billid:self.shneheList,
                tips: self.input,
                type: self.radio,
                status: self.status
            }, true).then(data => {
                self.loading = false;
                self.$message({
                    message: '修改成功',
                    type: 'success'
                });
                self.dialogFormVisible(true);

            }).catch(error => {
                self.loading = false;
            });
               
            }else{
                self.dialogVisible6 = true;
            }
           
        },
        /*确认事件*/
        // submitFunc(e) {
        //     let self = this;
        //     let order = this.order;
        //     self.loading = true;
        //     OrderApi.updatePrice({
        //         order_id: this.order_id,
        //         order: order,
        //     }, true).then(data =>
        //     {
        //         self.loading = false;
        //         self.$message({
        //             message: '修改成功',
        //             type: 'success'
        //         });
        //         self.dialogFormVisible(true);
        //     }).catch(error =>
        //     {
        //         self.loading = false;
        //     });
        // },

        /*关闭弹窗*/
        dialogFormVisible() {
            this.$emit('close', { openDialog: false });
        },
        // 过滤器
        formatDate(value) {
            let date = new Date(value * 1000);
            //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? ('0' + MM) : MM; //月补0
            let d = date.getDate();
            d = d < 10 ? ('0' + d) : d; //天补0
            let h = date.getHours();
            h = h < 10 ? ('0' + h) : h; //小时补0
            let m = date.getMinutes();
            m = m < 10 ? ('0' + m) : m; //分钟补0
            let s = date.getSeconds();
            s = s < 10 ? ('0' + s) : s; //秒补0
            return y + '-' + MM + '-' + d; //年月日
            // return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s; //年月日时分秒
        },
    }

};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/order/received/dialog/shenhe.vue